import { Helmet } from "react-helmet-async";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import FilterBar from "../../components/FilterBar/FilterBar";
import { useEffect, useRef, useState } from "react";
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";
import {
  changePageSizeSection,
  cleanMessageSection,
  getListaSection,
  getSectionHistoryList,
  getSectionPreview,
  getSectionProducts,
  getSectionSnippets,
  loadEmptySection,
  postSectionDownloadList,
} from "../../store/sections/actions";
import HistoryModal from "../../components/HistoryModal/HistoryModal";
import moment from "moment";
import { Pill } from "../../components/Pill/Pill";
import { useNavigate } from "react-router-dom";
import PillModal from "../../components/PillModal/PillModal";
import { openHtmlAsPdfPreview } from "../../helpers/utils/openHtmlAsPdfPreview";
import useAlert from "../../customHooks/useAlert";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import ActionList from "../../components/ActionList/ActionList";
import { PAGE_SIZE_OPTIONS } from "../../constants/pagination";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import downloadBase64File from "../../helpers/downloadBase64File";

const SectionsList = ({
  getListSectionRequest,
  getSectionHistoryList,
  getSectionProducts,
  getSectionSnippets,
  getSectionPreviewRequest,
  listaSection,
  listaSectionHistory,
  loadingSection,
  loadingSectionHistory,
  messageSection,
  cleanMessageSection,
  errorLoadingSectionHistory,

  sectionProducts,
  loadingProducts,
  errorProducts,

  sectionSnippets,
  loadingSnippets,
  errorSnippets,

  sectionPreview,
  errorSectionPreview,

  loadEmptySection,

  sectionList,
  errorSectionList,
  postSectionDownloadList,

  pageSizeSection,
  changePageSizeSection,
}) => {
  const [objFilter, setObjFilter] = useState({
    status: true,
    createDateStart: null,
    updateDateStart: null,
    createDateEnd: null,
    updateDateEnd: null,
    regions: [],
    business: [],
    products: [],
    snippets: [],
    createUsers: [],
    updateUsers: [],
    searchText: null,
  });

  const [paginationModel, setPaginationModel] = useState({
    pageSize: pageSizeSection,
    page: 0,
  });

  const [currentPageHistory, setCurrentPageHistory] = useState(1);
  const [idCurrentSectionHistory, setIdCurrentSectionHistory] = useState(null);
  const pageSizeHistory = 10;
  const totalPagesHistory = Math.ceil(
    (listaSectionHistory?.totalRecords || 0) / pageSizeHistory
  );
  const handlePageChangeHistory = (page) => {
    if (!idCurrentSectionHistory) return;
    if (page < 1 || page > totalPagesHistory) return;
    setCurrentPageHistory(page);

    getSectionHistoryList({
      sectionId: idCurrentSectionHistory,
      page,
    });
  }

  const { errorAlert, successAlert } = useAlert();

  const isFirstRender = useIsFirstRender();
  const navigate = useNavigate();
  const titlePreviewRef =  useRef("");

  const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });
    changePageSizeSection(pageSize);

    getListSectionRequest({
      pageNumber: page + 1,
      pageSize: pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      regions: objFilter.regions,
      business: objFilter.business,
      products: objFilter.products,
      snippets: objFilter.snippets,
      createUsers: objFilter.createUsers,
      updateUsers: objFilter.updateUsers,
      searchText: objFilter.searchText,
      status: objFilter.status,
    });
  };
  const handleSortChange = (model) => {
    console.log(model);
  };
  const handleRowClick = (params) => {
    navigate(`/section?id=${params.id}`);
  };
  const fetchSectionHistory = (sectionId) => {
    getSectionHistoryList({ sectionId, page: 1 });
  };
  const handleDetailSectionHistory = (item) => {
    window.open(`/section?idHistory=${item.idHistory}`, "_blank");
  };
  const fetchQuantityProducts = (sectionId) => {
    getSectionProducts({ sectionId });
  };

  const fetchQuantitySnippets = (sectionId) => {
    getSectionSnippets({ sectionId });
  }
  const handleSectionPreview = (e, sectionId, title) => {
    e.stopPropagation();
    titlePreviewRef.current = title;
    getSectionPreviewRequest({ sectionId });
  }
  const handleDownladSectionList = () => {
    const normalizedFilter = {
      ...objFilter,
      createDateStart: objFilter.createDateStart || null,
      createDateEnd: objFilter.createDateEnd || null,
      updateDateStart: objFilter.updateDateStart || null,
      updateDateEnd: objFilter.updateDateEnd || null,
    }

    postSectionDownloadList({ objFilter: normalizedFilter });
  }

  const actions = useContextActions({
    context: "section",
    screen: "list",
  });

  const columns = [
    {
      field: "createDate",
      headerName: "Creation date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "updateDate",
      headerName: "Update date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "regionName",
      headerName: "Region",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "businessName",
      headerName: "Business",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "title",
      headerName: "Section Title",
      flex: 2,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "description",
      headerName: "Section Description",
      flex: 2,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "totalProducts",
      headerName: "Products",
      //flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalProducts}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M272 32L368 32C385.7 32 400 46.3 400 64C400 81.7 385.7 96 368 96L272 96C254.3 96 240 81.7 240 64C240 46.3 254.3 32 272 32zM176 208C176 172.7 204.7 144 240 144L400 144C435.3 144 464 172.7 464 208C464 232.1 450.7 253.1 431 264C450.7 274.9 464 295.9 464 320C464 344.1 450.7 365.1 431 376C450.7 386.9 464 407.9 464 432C464 456.1 450.7 477.1 431 488C450.7 498.9 464 519.9 464 544C464 579.3 435.3 608 400 608L240 608C204.7 608 176 579.3 176 544C176 519.9 189.3 498.9 209 488C189.3 477.1 176 456.1 176 432C176 407.9 189.3 386.9 209 376C189.3 365.1 176 344.1 176 320C176 295.9 189.3 274.9 209 264C189.3 253.1 176 232.1 176 208z"
                    fill="white"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantityProducts(params.row.id);
          }}
          loading={loadingProducts}
          data={sectionProducts}
          error={errorProducts}
          view="section" //View que estamos singular
          variant="Products" //Variante no plural
        />
      ),
    },
    {
      field: "totalSnippets",
      headerName: "Snippets",
      //flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalSnippets}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    fill="white"
                    d="M296.5 69.2C311.4 62.3 328.6 62.3 343.5 69.2L562.1 170.2C570.6 174.1 576 182.6 576 192C576 201.4 570.6 209.9 562.1 213.8L343.5 314.8C328.6 321.7 311.4 321.7 296.5 314.8L77.9 213.8C69.4 209.8 64 201.3 64 192C64 182.7 69.4 174.1 77.9 170.2L296.5 69.2zM112.1 282.4L276.4 358.3C304.1 371.1 336 371.1 363.7 358.3L528 282.4L562.1 298.2C570.6 302.1 576 310.6 576 320C576 329.4 570.6 337.9 562.1 341.8L343.5 442.8C328.6 449.7 311.4 449.7 296.5 442.8L77.9 341.8C69.4 337.8 64 329.3 64 320C64 310.7 69.4 302.1 77.9 298.2L112 282.4zM77.9 426.2L112 410.4L276.3 486.3C304 499.1 335.9 499.1 363.6 486.3L527.9 410.4L562 426.2C570.5 430.1 575.9 438.6 575.9 448C575.9 457.4 570.5 465.9 562 469.8L343.4 570.8C328.5 577.7 311.3 577.7 296.4 570.8L77.9 469.8C69.4 465.8 64 457.3 64 448C64 438.7 69.4 430.1 77.9 426.2z"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantitySnippets(params.row.id);
          }}
          loading={loadingSnippets}
          data={sectionSnippets}
          error={errorSnippets}
          view="section" //View que estamos singular
          variant="Snippets" //Variante no plural
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      //flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <ActionList id={params.row.id} title={params.row.title} onPreview={handleSectionPreview} actions={actions}/>
      ),
    },
    {
      field: "id",
      headerName: "History",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <HistoryModal
          trigger={
            <Button color="" style={{ width: 50, height: 50 }}>
              <i className="fas fa-history"></i>
            </Button>
          }
          fetchHistory={() => {
            fetchSectionHistory(params.value)
            setCurrentPageHistory(1);
            setIdCurrentSectionHistory(params.value);
          }}
          loading={loadingSectionHistory}
          data={listaSectionHistory?.records}
          onDetail={handleDetailSectionHistory}
          errorLoadingHistory={errorLoadingSectionHistory}

          handlePageChange={handlePageChangeHistory}
          totalPages={totalPagesHistory}
          currentPage={currentPageHistory}

          columns={[
            {
              key: "updateDate",
              render: (item) =>
                moment(item.updateDate ?? item.createDate).format(
                  "DD MMM/YY hh:mm A",
                ),
            },
            { key: "title" },
            {
              key: "updateUser",
              render: (item) => item.updateUser ?? item.createUser,
            },
          ]}
        />
      ),
    },
  ];

  useEffect(() => {
    if (messageSection) {
      errorAlert(
        `${messageSection !== null ? messageSection : "Something wrong, try again later."}`,
        {
          timer: undefined,
          timerProgressBar: false,
          didClose: () => cleanMessageSection(),
        }
      );
    }
    // eslint-disable-next-line
  }, [messageSection]);

  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

    getListSectionRequest({
      pageNumber: 1,
      pageSize: paginationModel.pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      regions: objFilter.regions,
      business: objFilter.business,
      products: objFilter.products,
      snippets: objFilter.snippets,
      createUsers: objFilter.createUsers,
      updateUsers: objFilter.updateUsers,
      searchText: objFilter.searchText,
      status: objFilter.status,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objFilter]);

  useEffect(() => {
    if (sectionPreview) {
      openHtmlAsPdfPreview({
        html: sectionPreview.html,
        title: titlePreviewRef.current || "Section Preview",
      })
    }

    return () => {
      loadEmptySection();
    }
    // eslint-disable-next-line
  }, [sectionPreview]);
  useEffect(() => {
    if(errorSectionPreview) {
        errorAlert(
          errorSectionPreview ? errorSectionPreview : "Try again later!",
          {
            didClose: () => {
              cleanMessageSection();
            },
          }
        );
      }
      // eslint-disable-next-line
  }, [errorSectionPreview]);
  useEffect(() => {
      async function handleDownload() {
        if (sectionList) {
          const base64 = sectionList;
          const fileName = `Sections_${moment().format("YYYYMMDD")}.xlsx`;
  
          const success = await downloadBase64File(base64, fileName, "xlsx");
  
          if (success) {
            successAlert("Sections list downloaded successfully", {
              didClose: () => {
                cleanMessageSection();
              },
            });
          }
  
          return;
        }
  
        if (errorSectionList) {
          errorAlert(errorSectionList || "Try again later!", {
            didClose: () => {
              cleanMessageSection();
            },
          });
        }
      }
  
      handleDownload();
  
      return () => {
        cleanMessageSection();
      }
    // eslint-disable-next-line
    }, [sectionList, errorSectionList]);

  return (
    <div className="page-content">
      <Helmet>
        <title>Sections</title>
      </Helmet>

      <Container fluid>
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <Row>
                  <div className="d-flex justify-content-between my-2">
                    <h2>SECTIONS</h2>
                    <ActionButtons 
                      actions={actions}
                      context="section"
                      handlers={{
                        create: () => navigate("/section"),
                      }}
                    />
                  </div>

                  <Row>
                    <Col md={12}>
                      <FilterBar
                        setObjFilter={setObjFilter}
                        placeholderSearch="Search by section title or description"
                        isFirstRender={isFirstRender}
                        variant="sections"
                      />
                    </Col>
                  </Row>

                  <Row className="my-2">
                    {loadingSection ? (
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ height: "400px", width: "100%" }}
                      >
                        <Spinner
                          color="primary"
                          style={{ height: "5rem", width: "5rem" }}
                        />
                      </div>
                    ) : (
                      <>
                        <div className="d-flex align-center justify-content-end gap-2 mb-3">
                          <ButtonCustom 
                            type="export"
                            onClick={handleDownladSectionList}
                            disabled={listaSection.records.length === 0}
                          />
                        </div>
                        <CustomDatatable
                          columns={columns}
                          rows={listaSection.records}
                          pagination
                          paginationMode="server"
                          rowCount={listaSection?.totalRecords ?? 0}
                          paginationModel={paginationModel}
                          onPaginationModelChange={handlePageChange}
                          onSortModelChange={handleSortChange}
                          onRowClick={handleRowClick}
                          pageSizeOptions={PAGE_SIZE_OPTIONS}
                          checkboxSelection={false}
                          disableColumnFilter
                          disableColumnMenu
                        />
                      </>
                    )}
                  </Row>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = ({
  SectionReducer: {
    listaSection,
    listaSectionHistory,
    loadingSection,
    loadingSectionHistory,
    messageSection,
    errorLoadingSectionHistory,

    sectionProducts,
    loadingProducts,
    errorProducts,

    sectionSnippets,
    loadingSnippets,
    errorSnippets,
    sectionPreview,
    errorSectionPreview,
    
    sectionList,
    errorSectionList,

    pageSizeSection,
  },
}) => ({
  listaSection,
  listaSectionHistory,
  loadingSection,
  loadingSectionHistory,
  messageSection,
  errorLoadingSectionHistory,

  sectionProducts,
  loadingProducts,
  errorProducts,

  sectionSnippets,
  loadingSnippets,
  errorSnippets,
  sectionPreview,
  errorSectionPreview,

  sectionList,
  errorSectionList,

  pageSizeSection,
});

const mapDispatchToProps = {
  getListSectionRequest: getListaSection.request,
  getSectionHistoryList: getSectionHistoryList.request,
  getSectionProducts: getSectionProducts.request,
  getSectionSnippets: getSectionSnippets.request,
  postSectionDownloadList: postSectionDownloadList.request,

  getSectionPreviewRequest: getSectionPreview.request,
  cleanMessageSection: cleanMessageSection,
  loadEmptySection,
  changePageSizeSection: changePageSizeSection,
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionsList);
